import { Modal, Text, TouchableOpacity, TouchableWithoutFeedback, View } from "react-native";
import MaterialCommunityIcons from "react-native-vector-icons/MaterialCommunityIcons";
import styles from './Accueil.styles'
import { MenuContextuelProps } from "./Accueil.types";
import { useCallback } from "react";
import { useSessionStore } from "../../lib/Store/sessionStore.component";
import { isWeb } from '@commonStyle';
import { navigation as navigationObject } from '../../lib/Navigation/Navigation.component'

export default function MenuContextuel({ visible, navigation, onClose } : MenuContextuelProps){
    const { clearSession } = useSessionStore();
    const handleDeconnexion = useCallback(async () => {
        await clearSession()
        onClose();
        !isWeb ? navigationObject.replace('Connexion', navigation) : navigationObject.navigate('/', navigation);
    }, [clearSession, navigation, onClose])
    return (
        <Modal
            transparent
            visible={visible}
            animationType="fade"
            onRequestClose={onClose}
        >
            <TouchableWithoutFeedback onPress={onClose}>
            <View style={styles.overlay}>
                <TouchableWithoutFeedback>
                <View style={styles.menuContainer}>
                    {/* 
                    {currentDatabase?.fichesAgent && currentDatabase.fichesAgent.length > 1 &&(
                        <TouchableOpacity
                        style={styles.menuItem}
                        onPress={() => {
                            onClose();
                            navigationObject.navigate('SelectionFicheAgent', navigation);
                        }}
                        >
                        <MaterialCommunityIcons
                            name="account-switch-outline"
                            size={22}
                            color="#384454"
                        />
                        <Text style={styles.menuText}>
                            Changer de compte
                        </Text>
                        </TouchableOpacity>
                    )}
                    {accessibleDatabases.length > 1 &&(
                        <TouchableOpacity
                            style={styles.menuItem}
                            onPress={() => {
                                onClose();
                                navigationObject.navigate('Collectivite', navigation);
                            }}
                        >
                            <MaterialCommunityIcons
                                name="office-building-outline"
                                size={22}
                                color="#384454"
                            />
                            <Text style={styles.menuText}>
                                Changer de collectivité
                            </Text>
                        </TouchableOpacity>
                    )} 
                    {hasTour && <TouchableOpacity
                        style={styles.menuItem}
                        onPress={() => {
                            onClose();
                            navigationObject.navigate('TourProduit', navigation);
                        }}
                    >
                        <MaterialCommunityIcons
                        name="play-circle-outline"
                        size={22}
                        color="#384454"
                        />
                        <Text style={styles.menuText}>
                        Tour produit
                        </Text>
                    </TouchableOpacity>}
                    <View style={styles.separator} />
                    */}
                    <TouchableOpacity
                        style={styles.menuItem}
                        onPress={handleDeconnexion}
                    >
                        <MaterialCommunityIcons
                        name="logout"
                        size={22}
                        color="#384454"
                        />
                        <Text style={styles.menuText}>Se déconnecter</Text>
                    </TouchableOpacity>
                </View>
                </TouchableWithoutFeedback>
            </View>
            </TouchableWithoutFeedback>
        </Modal>
    )
}
